import React, { Component } from "react";
import classNames from "classnames";
import Util from "../../../util/common";
import { goldlogAutoExpInit, questionnaireFloatClkGoldlog } from "../../../../goldlog";

import "./index.scss";

const SURVEY_URL = "https://survey.1688.com/apps/zhiliao/Lnkec5MDq";
const FEEDBACK_ICON_URL = "https://gw.alicdn.com/imgextra/i4/O1CN01Mz6ah61zZTqz9s9YX_!!6000000006728-1-tps-168-180.gif";

class QuestionnaireIcon extends Component {
  constructor(props) {
    super(props);
    const cosite = Util.getUrlParam("cosite");
    this.logParams = {
      position: "old-sem-pc-list",
      cosite,
    };
  }

  componentDidMount() {
    goldlogAutoExpInit();
  }

  handleClick = () => {
    questionnaireFloatClkGoldlog(this.logParams);
  };

  render() {
    return (
      <div
        className={classNames(
          "questionnaire-icon",
          "questionnaire-float-auto-exp"
        )}
        data-track-param={Util.objToUrlParams(this.logParams)}
        onClick={this.handleClick}
      >
        <a
          href={SURVEY_URL}
          target="_blank"
          rel="noreferrer"
        >
          <img
            className="questionnaire-icon-img"
            src={FEEDBACK_ICON_URL}
            alt="体验反馈"
          />
        </a>
      </div>
    );
  }
}

export default QuestionnaireIcon;
